module.exports = __webpack_public_path__ + "img/bg1.4a30a0fd.png";